import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class AiTokensService {
    private apiUrl = environment.apiUrl;

    constructor(private http: HttpClient) { }

    // Get all active token packages for purchase (filtered by country name)
    getPackages(countryName?: string): Observable<any> {
        let url = `${this.apiUrl}/ai-tokens/packages`;
        if (countryName) {
            url += `?country=${encodeURIComponent(countryName)}`;
        }
        return this.http.get<any>(url);
    }

    // Get current user's token balance
    getBalance(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/ai-tokens/balance`);
    }

    // Get user's purchase history
    getPurchaseHistory(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/ai-tokens/purchase-history`);
    }

    // Get latest purchase (for success page)
    getLatestPurchase(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/ai-tokens/latest-purchase`);
    }

    // Purchase a token package
    purchasePackage(packageId: string, paymentMethod?: string): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/ai-tokens/purchase`, {
            packageId,
            paymentMethod
        });
    }

    // Check if user has enough tokens for an operation
    checkAvailability(tokensNeeded: number): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/ai-tokens/check-availability`, {
            tokensNeeded
        });
    }
}
